import { render, staticRenderFns } from "./StagingAuthorSectionEditor.vue?vue&type=template&id=694903a0"
import script from "./StagingAuthorSectionEditor.vue?vue&type=script&lang=ts"
export * from "./StagingAuthorSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./StagingAuthorSectionEditor.vue?vue&type=style&index=0&id=694903a0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports